/** @license ISC License (c) copyright 2017 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

// isBoolean : a -> Boolean
function isBoolean(x) {
  return typeof x === 'boolean'
}

module.exports = isBoolean
